import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-695a40bf"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "col-12 col-md-12" }
const _hoisted_2 = { class: "d-flex" }
const _hoisted_3 = {
  class: "ms-0",
  style: {"width":"85%"}
}
const _hoisted_4 = { class: "ms-auto" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" Ambil Data ")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1))
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("div", { class: "d-flex gap-2 align-items-center" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info-circle" }),
    /*#__PURE__*/_createElementVNode("span", null, [
      /*#__PURE__*/_createTextVNode(" Pisahkan URL Postingan/Berita menggunakan "),
      /*#__PURE__*/_createElementVNode("strong", null, "Enter"),
      /*#__PURE__*/_createTextVNode(" atau '"),
      /*#__PURE__*/_createElementVNode("strong", null, ","),
      /*#__PURE__*/_createTextVNode("' (Koma) ")
    ])
  ])
], -1))
const _hoisted_9 = {
  key: 0,
  class: "col-12 col-md-12"
}
const _hoisted_10 = { class: "row g-4" }
const _hoisted_11 = { class: "col-sm-12 col-md-4" }
const _hoisted_12 = { class: "card-body text-center" }
const _hoisted_13 = { class: "d-flex justify-content-center align-items-center gap-4 mb-2" }
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-building text-white fa-3x" }, null, -1))
const _hoisted_15 = { class: "mb-0 text-start text-white fw-bold" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-0 text-white fw-semibold" }, "URL Berita", -1))
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "border-light opacity-50" }, null, -1))
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-uppercase text-white" }, "SIPUTRA", -1))
const _hoisted_19 = { class: "col-sm-12 col-md-4" }
const _hoisted_20 = { class: "card-body text-center" }
const _hoisted_21 = { class: "d-flex justify-content-center align-items-center gap-4 mb-2" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-robot text-white fa-3x" }, null, -1))
const _hoisted_23 = { class: "mb-0 text-start text-white fw-bold" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-0 text-white fw-semibold" }, "URL Berita", -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "border-light opacity-50" }, null, -1))
const _hoisted_26 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-uppercase text-white" }, "SCRAPER", -1))
const _hoisted_27 = { class: "col-sm-12 col-md-4" }
const _hoisted_28 = { class: "card-body text-center" }
const _hoisted_29 = { class: "d-flex justify-content-center align-items-center gap-4 mb-2" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-link text-white fa-3x" }, null, -1))
const _hoisted_31 = { class: "mb-0 text-start text-white fw-bold" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-0 text-white fw-semibold" }, "URL Berita", -1))
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "border-light opacity-50" }, null, -1))
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fw-bold text-uppercase text-white" }, "URL BARU", -1))
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { class: "card" }
const _hoisted_37 = { class: "card-body px-2" }
const _hoisted_38 = ["title"]
const _hoisted_39 = ["href"]
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-share text-primary] fs-3" }, null, -1))
const _hoisted_41 = [
  _hoisted_40
]
const _hoisted_42 = { key: 1 }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-info fs-3" }, null, -1))
const _hoisted_44 = /*#__PURE__*/_createTextVNode(" Link URL Tidak Tersedia!")
const _hoisted_45 = [
  _hoisted_43,
  _hoisted_44
]
const _hoisted_46 = {
  key: 1,
  class: "mt-2"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { style: {"margin-left":"2px"} }, "Form Berita")
], -1))
const _hoisted_48 = ["title"]
const _hoisted_49 = ["href"]
const _hoisted_50 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fa fa-share text-primary fs-3" }, null, -1))
const _hoisted_51 = [
  _hoisted_50
]
const _hoisted_52 = {
  class: "row px-4",
  style: {"margin-top":"2rem !important"}
}
const _hoisted_53 = { class: "col-12 col-md-4" }
const _hoisted_54 = {
  class: "d-flex align-items-center gap-2 mx-5 mt-3 mb-2 text-primary",
  style: {"font-size":"14px"}
}
const _hoisted_55 = { class: "d-flex align-items-center gap-2" }
const _hoisted_56 = { class: "col-12 col-md-8" }
const _hoisted_57 = { class: "col-12 col-md-12" }
const _hoisted_58 = { class: "col-12 col-md-12" }
const _hoisted_59 = { class: "col-12 col-md-4" }
const _hoisted_60 = { class: "col-12 col-md-4" }
const _hoisted_61 = { class: "d-flex align-items-center gap-2" }
const _hoisted_62 = { class: "col-md-4" }
const _hoisted_63 = /*#__PURE__*/_createTextVNode(" AD Value ")
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "fas fa-exclamation-circle ms-2 fs-7",
  "data-bs-toggle": "tooltip",
  "data-bs-placement": "top",
  title: `Berdasarkan master data media`
}, null, -1))
const _hoisted_65 = { class: "col-12 col-md-12" }
const _hoisted_66 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "fas fa-align-justify text-white" }, null, -1))
const _hoisted_67 = /*#__PURE__*/_createTextVNode(" Fix OCR Text ")

import { ref, watch, computed, onMounted } from "vue";
import ApiService from "@/core/services/ApiService";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { formatDateTime } from "@/global-helper/handler";

interface IProps {
  source: string,
  form: any;
  type: string;
}


export default /*#__PURE__*/_defineComponent({
  props: {
    source: { type: String, required: true },
    form: { type: null, required: true },
    type: { type: String, required: true }
  },
  emits: ["update:form"],
  setup(__props: any, { emit }) {

const props = __props as {
  source: string,
  form: any;
  type: string;
}


const get_data_button = ref<HTMLElement | null>(null);
const news_type = ref<any>([]);
const active_names = ref('1');
const form = computed({
  get: () => props.form,
  set: (val) => emit("update:form", val),
});
const file_source = ref("");
const source = ref<any>(props.source);
const sources = ref([
  { value: "news", label: "Media Online", icon: "fas fa-pager" },
  { value: "media_cetak", label: "Media Cetak", icon: "far fa-newspaper" },
  { value: "media_tv", label: "Media TV", icon: "fas fa-tv" },
  { value: "radio", label: "Radio", icon: "bi bi-broadcast-pin" },
  { value: "running_text", label: "Running Text", icon: "bi bi-card-text" },
]);
const sentiment_options = ref([
  { value: null, label: "Tidak Ada", icon: "" },
  { value: 1, label: "Positif", icon: "far fa-smile fs-2x text-success" },
  { value: 0, label: "Netral", icon: "far fa-meh text-primary fs-2x" },
  { value: -1, label: "Negatif", icon: "far fa-frown text-danger fs-2x" },
]);
const data_url = ref<any>([]);
const is_detail_url = ref({
  key: "",
  status: false,
});

const checkContent = async () => {
  form.value = [];
  data_url.value = [];

  if (file_source.value && file_source.value !== "" && file_source.value !== null) {
    const data_urls = (file_source.value || '')
    .replace(/[\r\n]+/g, ', ')
    .replace(/\s*,\s*/g, ', ')
    .trim();
  
    checkURLMany(data_urls);
  } else {
    Swal.fire({
      position: "top-end",
      icon: "error",
      toast: true,
      title: "ERROR. Mohon masukan URL berita!!",
      showConfirmButton: false,
      timer: 3000,
    });
  }

};

const addItems = (arr, status) => {
  if (Array.isArray(arr) && arr.length > 0) {
    const newItems = arr
      .filter((element) => !form.value.some((item) => item.file_source === element))
      .map((element) => ({
        source: "news",
        file_source: element,
        title: "",
        account: "",
        jenis_data: "",
        date: "",
        journalist: "",
        sentiment: 0,
        ad_value: 0,
        content: "",
        status_data: status,
      }));

    form.value = [...form.value, ...newItems];
  }
};

const checkURLMany = async (urls: any) => {
  const payload: any = {
    urls: urls,
  };

  ApiService.post("/streams/check-urls", payload)
  .then((response) => {
    data_url.value = response.data;

    addItems(response?.data?.not_exist_url, "not_exist_url");

    const url_not_exist = response?.data?.not_exist_url.join(', ')
    checkDataURLMany(url_not_exist);
  })
  .catch((error) => {
    form.value = [];
  });
}

const checkDataURLMany = async (urls: any) => {
  const payload: any = { urls };

  try {
    const response = await ApiService.post("/streams/check-newspapers", payload);
    const crawled_data = response?.data?.crawled_data ?? [];

    if (Array.isArray(crawled_data) && crawled_data.length > 0) {
      const updated = form.value.map((element) => {
        const found = crawled_data.find((item) => item.url === element.file_source);
        if (!found) return element;

        const data_update = { 
          ...element,
          title: found.title || "",
          account: found.account || "",
          jenis_data: found.jenis_data || "",
          date: formatDateTime(found.date),
          sentiment: found.sentiment || 0,
          journalist: found.journalist || "",
          content: found.content || "",
        }

        checkAdValue(data_update);

        return data_update;
      });

      form.value = updated;
    }
  } catch (error) {
    form.value = [];
  }
};

const normalizeUrl = (url: string) => {
  if (url.startsWith("http://") || url.startsWith("https://")) {
    return url;
  }
  return "https://" + url;
};

const checkAdValue = (data: any) => {
  const url = `/media?media_like=${data.account}&limit=100&page=1&source=${source.value}`;
  return ApiService.get(url)
    .then((response) => {
      data.ad_value = response.data.data.ad_value || 0;
    })
    .catch((error) => {
      data.ad_value = 0;
    });
};

const convertText = (item) => {
  if (!item || !item.content) return;

  let text = item.content.split("\n\n");
  let newText = "";

  for (let i = 0; i < text.length; i++) {
    let perTextArray = text[i].split("\n");
    for (let j = 0; j < perTextArray.length; j++) {
      if (perTextArray[j].charAt(perTextArray[j].length - 1) === "-") {
        newText += perTextArray[j].replace(/-/g, "");
      } else {
        newText += perTextArray[j] + " ";
      }
    }
    newText += "\n";
  }

  item.content = newText.trim(); // ubah langsung
};

const getDataOptionsType = (key) => {
  const params: any = {
    ...(key ? {key} : {}),
    ...(source.value ? { source: source.value} : {}) 
  }

  const query = Object.keys(params)
    .map((key) => `${key}=${params[key]}`)
    .join("&");

  ApiService.get(`/options/news-type?${query}`)
  .then((response) => {
    news_type.value = response.data.news_type_data;
  })
  .catch((error) => {
    news_type.value = [];
  });
}
const checkSource = (source) => {
  const result = sources.value.find((el: any) => el.value === source);

  return result;
};

const showDetailURL = (key: string) => {
  if (is_detail_url.value.key === key) {
    is_detail_url.value.status = false;
    is_detail_url.value.key = "";
  } else {
    is_detail_url.value.status = true;
    is_detail_url.value.key = key;
  }
};

onMounted(() => {
  getDataOptionsType("");
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_option_group = _resolveComponent("el-option-group")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_el_form_item, {
        label: "* URL Berita",
        rules: {
        required: false,
        message: 'URL Berita Wajib Diisi',
        trigger: ['blur', 'change'],
      }
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_el_input, {
                type: "textarea",
                placeholder: "URL Berita",
                modelValue: file_source.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((file_source).value = $event)),
                rows: "4",
                onBlur: _cache[1] || (_cache[1] = ($event: any) => (file_source.value = file_source.value.trim()))
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-primary btn-lg btn-block",
                onClick: checkContent,
                ref: (_value, _refs) => {
                  _refs['get_data_button'] = _value
                  get_data_button.value = _value
                }
              }, _hoisted_7, 512)
            ])
          ]),
          _hoisted_8
        ]),
        _: 1
      })
    ]),
    (Object.keys(data_url.value).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", {
                class: "card text-white bg-success border-0 shadow-sm hover-card",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (showDetailURL('siputra_exist_url')))
              }, [
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("div", _hoisted_13, [
                    _hoisted_14,
                    _createElementVNode("div", null, [
                      _createElementVNode("h3", _hoisted_15, _toDisplayString(data_url.value.siputra_exist_url.length), 1),
                      _hoisted_16
                    ])
                  ]),
                  _hoisted_17,
                  _hoisted_18
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", {
                class: "card text-white bg-warning border-0 shadow-sm hover-card",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (showDetailURL('scraper_exist_url')))
              }, [
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("div", _hoisted_21, [
                    _hoisted_22,
                    _createElementVNode("div", null, [
                      _createElementVNode("h3", _hoisted_23, _toDisplayString(data_url.value.scraper_exist_url.length), 1),
                      _hoisted_24
                    ])
                  ]),
                  _hoisted_25,
                  _hoisted_26
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_27, [
              _createElementVNode("div", {
                class: "card text-white bg-primary border-0 shadow-sm hover-card",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (showDetailURL('not_exist_url')))
              }, [
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("div", _hoisted_29, [
                    _hoisted_30,
                    _createElementVNode("div", null, [
                      _createElementVNode("h3", _hoisted_31, _toDisplayString(data_url.value.not_exist_url.length), 1),
                      _hoisted_32
                    ])
                  ]),
                  _hoisted_33,
                  _hoisted_34
                ])
              ])
            ])
          ]),
          (is_detail_url.value.status)
            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                _createElementVNode("div", _hoisted_36, [
                  _createElementVNode("div", _hoisted_37, [
                    _createElementVNode("h5", null, " Daftar link URL " + _toDisplayString(is_detail_url.value.key == 'siputra_exist_url'
              ? 'yang telah terdaftar pada SIPUTRA:'
              : is_detail_url.value.key == 'scraper_exist_url'
              ? 'yang telah terdaftar pada scraper:'
              : 'baru:'), 1),
                    (data_url.value[is_detail_url.value.key].length > 0)
                      ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(data_url.value[is_detail_url.value.key], (item, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: index,
                            class: "w-100"
                          }, [
                            _createTextVNode(_toDisplayString(index + 1) + ". ", 1),
                            _createElementVNode("span", {
                              class: "url-text",
                              title: item
                            }, _toDisplayString(item), 9, _hoisted_38),
                            _createElementVNode("a", {
                              href: item,
                              style: {"margin-left":"2px"},
                              target: "_blank"
                            }, _hoisted_41, 8, _hoisted_39)
                          ]))
                        }), 128))
                      : (_openBlock(), _createElementBlock("div", _hoisted_42, _hoisted_45))
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_unref(form).length > 0)
      ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
          _hoisted_47,
          _createVNode(_component_el_collapse, {
            modelValue: active_names.value,
            "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((active_names).value = $event)),
            accordion: ""
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(form), (item, index) => {
                return (_openBlock(), _createBlock(_component_el_collapse_item, {
                  key: index,
                  name: index + 1,
                  class: "border"
                }, {
                  title: _withCtx(() => [
                    _createTextVNode(_toDisplayString(index + 1) + ". ", 1),
                    _createElementVNode("span", {
                      class: "url-text",
                      title: item.file_source
                    }, _toDisplayString(item.file_source), 9, _hoisted_48),
                    _createElementVNode("a", {
                      href: item.file_source,
                      style: {"margin-left":"2px"},
                      target: "_blank"
                    }, _hoisted_51, 8, _hoisted_49)
                  ]),
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_52, [
                      _createElementVNode("div", _hoisted_53, [
                        _createVNode(_component_el_form_item, {
                          label: "Jenis Berita",
                          prop: `${index}.jenis_data`,
                          rules: {
                  required: news_type.value.length > 0 ? true : false,
                  message: 'Jenis Berita Wajib Diisi',
                  trigger: ['blur', 'change'],
                }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              modelValue: item.jenis_data,
                              "onUpdate:modelValue": ($event: any) => ((item.jenis_data) = $event),
                              class: "form-control-custom",
                              placeholder: "Pilih Jenis Berita",
                              remote: "",
                              "remote-method": getDataOptionsType
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(news_type.value, (group) => {
                                  return (_openBlock(), _createBlock(_component_el_option_group, {
                                    key: group._id
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_54, [
                                        _createElementVNode("i", {
                                          class: _normalizeClass(`${checkSource(group?.source).icon}`),
                                          style: {"font-size":"14px"}
                                        }, null, 2),
                                        _createTextVNode(" " + _toDisplayString(checkSource(group.source).label), 1)
                                      ]),
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.types, (type) => {
                                        return (_openBlock(), _createBlock(_component_el_option, {
                                          key: type.name,
                                          label: type.name,
                                          value: type.name
                                        }, {
                                          default: _withCtx(() => [
                                            _createElementVNode("span", _hoisted_55, _toDisplayString(type.name), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["label", "value"]))
                                      }), 128))
                                    ]),
                                    _: 2
                                  }, 1024))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1032, ["prop", "rules"])
                      ]),
                      _createElementVNode("div", _hoisted_56, [
                        _createVNode(_component_el_form_item, {
                          label: "Nama Media",
                          prop: `${index}.account`,
                          rules: {
                  required: true,
                  message: 'Nama Media Wajib Diisi',
                  trigger: ['blur', 'change'],
                }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              type: "text",
                              modelValue: item.account,
                              "onUpdate:modelValue": ($event: any) => ((item.account) = $event),
                              placeholder: "Media",
                              disabled: true,
                              onBlur: ($event: any) => (item.account = item.account.trim())
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])
                          ]),
                          _: 2
                        }, 1032, ["prop"])
                      ]),
                      _createElementVNode("div", _hoisted_57, [
                        _createVNode(_component_el_form_item, {
                          label: "Judul Berita",
                          prop: `${index}.title`,
                          rules: {
                  required: true,
                  message: 'Judul Berita Wajib Diisi',
                  trigger: ['blur', 'change'],
                }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              type: "text",
                              placeholder: "Judul Berita",
                              modelValue: item.title,
                              "onUpdate:modelValue": ($event: any) => ((item.title) = $event),
                              rows: "2",
                              onBlur: ($event: any) => (item.title = item.title.trim())
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])
                          ]),
                          _: 2
                        }, 1032, ["prop"])
                      ]),
                      _createElementVNode("div", _hoisted_58, [
                        _createVNode(_component_el_form_item, {
                          label: "Tanggal Berita",
                          prop: `${index}.date`,
                          rules: {
                  required: true,
                  message: 'Tanggal Berita Wajib Diisi',
                  trigger: ['blur', 'change'],
                }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_date_picker, {
                              style: {"width":"100% !important"},
                              modelValue: item.date,
                              "onUpdate:modelValue": ($event: any) => ((item.date) = $event),
                              placeholder: "Tanggal Berita",
                              format: "YYYY-MM-DD HH:mm:ss",
                              "value-format": "YYYY-MM-DD HH:mm:ss",
                              name: "date",
                              type: "datetime"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1032, ["prop"])
                      ]),
                      _createElementVNode("div", _hoisted_59, [
                        _createVNode(_component_el_form_item, {
                          label: "Jurnalis",
                          prop: `${index}.journalist`,
                          rules: {
                  required: false,
                  message: 'Jurnalis Wajib Diisi',
                  trigger: ['blur', 'change'],
                }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              type: "text",
                              modelValue: item.journalist,
                              "onUpdate:modelValue": ($event: any) => ((item.journalist) = $event),
                              placeholder: "Jurnalis",
                              onBlur: ($event: any) => (item.journalist = item.journalist.trim())
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"])
                          ]),
                          _: 2
                        }, 1032, ["prop"])
                      ]),
                      _createElementVNode("div", _hoisted_60, [
                        _createVNode(_component_el_form_item, {
                          label: "Sentimen",
                          prop: `${index}.sentiment`,
                          rules: {
                  required: false,
                  message: 'Sentimen Wajib Diisi',
                  trigger: ['blur', 'change'],
                }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              class: "form-control-custom",
                              modelValue: item.sentiment,
                              "onUpdate:modelValue": ($event: any) => ((item.sentiment) = $event),
                              placeholder: "Sentimen"
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sentiment_options.value, (options) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    key: options.value,
                                    label: options.label,
                                    value: options.value
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("span", _hoisted_61, [
                                        _createElementVNode("i", {
                                          class: _normalizeClass(options.icon)
                                        }, null, 2),
                                        _createTextVNode(" " + _toDisplayString(options.label), 1)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["label", "value"]))
                                }), 128))
                              ]),
                              _: 2
                            }, 1032, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1032, ["prop"])
                      ]),
                      _createElementVNode("div", _hoisted_62, [
                        _createVNode(_component_el_form_item, {
                          label: "AD Value",
                          prop: `${index}.ad_value`,
                          rules: {
                  required: true,
                  message: 'AD Value Wajib Diisi',
                  trigger: ['blur', 'change'],
                }
                        }, {
                          label: _withCtx(() => [
                            _hoisted_63,
                            _hoisted_64
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              type: "number",
                              modelValue: item.ad_value,
                              "onUpdate:modelValue": ($event: any) => ((item.ad_value) = $event),
                              placeholder: "Ad Value"
                            }, null, 8, ["modelValue", "onUpdate:modelValue"])
                          ]),
                          _: 2
                        }, 1032, ["prop"])
                      ]),
                      _createElementVNode("div", _hoisted_65, [
                        _createVNode(_component_el_form_item, {
                          label: "Konten Berita",
                          prop: `${index}.content`,
                          rules: {
                  required: true,
                  message: 'Konten Berita Wajib Diisi',
                  trigger: ['blur', 'change'],
                }
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input, {
                              type: "textarea",
                              modelValue: item.content,
                              "onUpdate:modelValue": ($event: any) => ((item.content) = $event),
                              rows: "10",
                              onBlur: ($event: any) => (item.content = item.content.trim())
                            }, null, 8, ["modelValue", "onUpdate:modelValue", "onBlur"]),
                            _createVNode(_component_el_button, {
                              size: "small",
                              class: "btn btn-sm btn-primary my-5",
                              type: "primary",
                              onClick: ($event: any) => (convertText(item))
                            }, {
                              default: _withCtx(() => [
                                _hoisted_66,
                                _hoisted_67
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1032, ["prop"])
                      ])
                    ])
                  ]),
                  _: 2
                }, 1032, ["name"]))
              }), 128))
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})